/**
 * Interface for key/value storage
 */ export var StorageType;
(function(StorageType) {
    /** Local storage */ StorageType["LocalStorage"] = "localStorage";
    /** Session storage */ StorageType["SessionStorage"] = "sessionStorage";
})(StorageType || (StorageType = {}));
